import { useEffect, useState } from "react";
import InputXML from "../components/InputXML";
import x2js from 'x2js'
import { useLocation } from 'react-router-dom'

import { styled } from '@mui/material/styles';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import Tabela from "../components/TabelaSped";

import CircularProgress from '@mui/material/CircularProgress';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import Alert from '@mui/material/Alert';

function ImportarXMLSped({ location }) {
  location = useLocation();
  const [files, setFiles] = useState();
  const [allData, setAllData] = useState();
  const [cont, setCont] = useState(0);
  const [activeStep, setActiveStep] = useState(0);
  const linhas = [];
  const [nomeEmpresa, setNomeEmpresa] = useState("");
  const [dadosFiltrados, setDadosFiltrados] = useState();
  const [pdfNotas, setPdfNotas] = useState();
  const [retAtivo, setRetAtivo] = useState(false);
  const [autopecasAtivo, setAutopecasAtivo] = useState(false);
  const [autopecasRetAtivo, setAutopecasRetAtivo] = useState(false);
  const [construcaoCivilAtivo, setConstrucaoCivilAtivo] = useState(false);
  const [construcaoCivilRetAtivo, setConstrucaoCivilRetAtivo] = useState(false);

  function createData(Cod_Produto, NCM , Produto, UND, CFOP, CST_PIS, CST_COFINS
  ) {
    return {
        Cod_Produto, NCM, Produto, UND, CFOP, CST_PIS, CST_COFINS
    };
  }

  const dadosNotas = (dados) => {
    for (var nota in dados) {
      if (dados.hasOwnProperty(nota)) {
        console.log(dados)
        const qtdItem = (dados[nota].det.length ? dados[nota].det.length : 1);
        if (qtdItem > 1) { 
            for (var ind = 0; ind < qtdItem; ind++) {
              if (dados[nota].det[ind].imposto.PIS?.PISNT && dados[nota].det[ind].imposto.COFINS?.COFINSNT) {
                const codigoProduto = dados[nota].det[ind].prod.cProd;
                const ncm = dados[nota].det[ind].prod.NCM;
                const nomeProduto = dados[nota].det[ind].prod.xProd;
                const unidadeProduto = dados[nota].det[ind].prod.uTrib;
                const cfop = dados[nota].det[ind].prod.CFOP;
                const pis = dados[nota].det[ind].imposto.PIS.PISNT.CST;
                const cofins = dados[nota].det[ind].imposto.COFINS.COFINSNT.CST;

                linhas.push(createData(codigoProduto,
                  ncm,
                  nomeProduto,
                  unidadeProduto,
                  cfop,
                  pis,
                  cofins
                ))
              }
            }
          }else{
              if (dados[nota].det.imposto.PIS?.PISNT && dados[nota].det.imposto.COFINS?.COFINSNT) {
                const codigoProduto = dados[nota].det.prod.cProd;
                const ncm = dados[nota].det.prod.NCM;
                const nomeProduto = dados[nota].det.prod.xProd;
                const unidadeProduto = dados[nota].det.prod.uTrib;
                const cfop = dados[nota].det.prod.CFOP;
                const pis = dados[nota].det.imposto.PIS.PISNT.CST;
                const cofins = dados[nota].det.imposto.COFINS.COFINSNT.CST;

                linhas.push(createData(codigoProduto,
                  ncm,
                  nomeProduto,
                  unidadeProduto,
                  cfop,
                  pis,
                  cofins
                ))
              }

          }
              
          
        const dadosUnicos = removerDuplicatasPorPropriedades([...linhas]);
        setAllData(dadosUnicos);
        setDadosFiltrados(dadosUnicos)
      }
      setNomeEmpresa(dados[nota].dest.xNome)
  }
  }

function removerDuplicatasPorPropriedades(array) {
    // Usamos um Set para rastrear combinações únicas de nome, sobrenome e idade
    const conjuntoUnico = new Set();
    
    // Filtramos o array para manter apenas objetos únicos
    const arraySemDuplicatas = array.filter(item => {
      // Criamos uma chave única para cada objeto com base nas suas propriedades
      const chave = `${item.Cod_Produto}-${item.NCM}-${item.Produto}-${item.UND}-${item.CFOP}-${item.CST_PIS}-${item.CST_COFINS}`;
      
      // Verificamos se a chave já existe no Set
      if (!conjuntoUnico.has(chave)) {
        conjuntoUnico.add(chave); // Adicionamos a chave ao Set
        return true; // Mantemos o objeto no array resultante
      }
      return false; // Descarta o objeto se a chave já existe
    });

    return arraySemDuplicatas;
  }

  const getActiveContente = () => {
    switch (activeStep) {
      case 0:
        return (
          <div className="centralizar">
            <div className="UploadBox" >
            <InputXML title="Sped"
            setFiles={setFiles}
            />
            <div className="LadoDireito">
              {files !== undefined ?
                <div className="InfoProgress">
                  <div style={{marginBottom: '20px', marginRight: '5px'}}>
                    {cont === files.length ? <CheckCircleIcon sx={{ color: '#5049CC' }} size={90} /> : <CircularProgress sx={{ color: '#5049CC' }} size={28} />}
                    </div>
                  <div>
                    <div className="ArquivosProntos">
                    {cont + "/" + files.length + ' arquivos prontos'}
                    </div> 
                    <BorderLinearProgress variant="determinate" value={cont * 100 / files.length} />
                </div>
                </div> : ''}
              {files !== undefined && cont === files.length && allData.length === 0 ?
              <Alert severity="warning">Arquivo selecionado não possui  nenhuma<br/> NFe com CST 00, 20, 101, <br/>102, 400 ou 900. <br/>Por favor, selecione uma outra nota.</Alert>
              : ""}

              {files === undefined || cont !== files.length || allData.length === 0 ? "" : 
                <div className="BotaoContinuar">
                  <button id="continueButton"
                onClick={()=>{setActiveStep(activeStep+1)}}>
                <h3>Continuar</h3> <ArrowForwardIcon size={18}/>
              </button>
              </div>
              }
            </div>
          </div>
          </div>
        );
        case 1:
          return (
                      <Tabela nomeEmpresa={nomeEmpresa}
                        allData={allData}
                        setAllData={setAllData}
                        dadosFiltrados={dadosFiltrados}
                        setDadosFiltrados={setDadosFiltrados}
                      />
          )
        case 2:
          return (
            <div>Testando</div>
          )
      default:
        return (
          <div>nada pra ver</div>
        )
    }
  }

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 7,
    borderRadius: 5,
    width: 250,
    marginBottom: 30,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === 'light' ? '#5049CC' : '#5049CC',
    },
  }));

  useEffect(() => {
    if (files !== undefined) {
      var convert = new x2js();
      var chave, jsonDoc, prov, provPdf, todosDados, todosPdf;
      readmultifiles(files); 
      function readmultifiles(files) {
        setCont(0);
        var reader = new FileReader(); 
        function readFile(index) {
          if( index >= files.length ) return;
          var file = files[index];
          reader.onload = function(e) {  
            jsonDoc = convert.xml2js(reader.result);
            setCont(index + 1)
            if(jsonDoc.hasOwnProperty("nfeProc") && jsonDoc.nfeProc.hasOwnProperty("NFe") ){
              chave = jsonDoc.nfeProc.NFe.infNFe._Id.replace("NFe", "");
              prov = { [chave]: { ...jsonDoc.nfeProc.NFe.infNFe } }
              provPdf = { [chave] : reader.result}
              if (files.length === 1) {
                todosDados = prov;
                todosPdf = provPdf;
              } else {
                todosPdf = {...todosPdf, ...provPdf}
                todosDados = {...todosDados, ...prov}
              }
              if (index === files.length - 1) {
                dadosNotas(todosDados, todosPdf);
              }
            }
            readFile(index + 1)
          }
          reader.readAsText(file);
        }
        readFile(0);
      }
    }
  }, [files])


  return (
    <div className="App">
      {getActiveContente()}
        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
          {activeStep === 0 ? '' :
            <div className="BotaoVoltar">
              <button id="backButton"
                onClick={() => { setActiveStep(activeStep - 1) }}>
                <h4>Voltar</h4>
              </button>
            </div>}
        </div>
    </div>
  );
}

export default ImportarXMLSped;
